import FetchHelpers from '../../utils/FetchHelpers';
import formUrl from '../../utils/routes';
import { toFormData } from '../../utils/formUtils';

export default {
  create(params, userId) {
    const url = formUrl(`api/v1/admin/users/${userId}/bonuses`);
    return FetchHelpers.post(url, params);
  },
};
